
import { Component, OnInit, Output, EventEmitter, 
  ViewChildren,
  QueryList,
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes } from '@angular/core';

import {PredictiveComponent} from "../../../../common/predictive/predictive.component";
import { CleanersService } from '../../../../injections/cleaners.service';
import {Router} from "@angular/router";

@Component({
  selector: 'cleaners-search',
  templateUrl: '../../templates/partials/search-cleaners.html',
  animations: [
    trigger('searchCleaner', [
            state('void', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('inactive', style({
                overflow: 'hidden',
                "max-height": '0'
                
            })),
            state('active', style({
                display: 'block',
                "max-height": '1000px',

            })),
            transition('inactive => active', animate('400ms ease-in')),
            transition('active => inactive', animate('400ms ease-out'))
        ]),

    ],
})

export class SearchCleanersComponent implements OnInit {
  
  public searchActive = "active";
  public cleaners: Object = {};
  public searchObject = {
      document: null,
      email: null,
      phone: null,
      office: null,
      status: null
  };
  
  @ViewChildren(PredictiveComponent) predictives: QueryList<PredictiveComponent>;
  @Output() searchCleaners = new EventEmitter();
  constructor(private cleanersService: CleanersService, private router: Router) {}

  public emptyPredictiveArray(type){
    this.predictives.forEach((item) => {
        if(type != item.type){
          this.predictives.first.items = [];
        }else{
          if(item.inputValue != ''){
            this.setPredictive(item);
          }else{
            this.predictives.first.items = [];
          }
        }
    });    
  }

  public emptyOtherInputs(type: string){
        //console.log(type);
        this.searchObject = {
            document: null,
            email: null,
            phone: null,
            office: null,
            status: null
        };
        this.predictives.first.items = [];
  }

  private setPredictive(predictive: PredictiveComponent) {
      switch (predictive.type){
        case 'cleaner':
        this.cleanersService.findCleanerByName(predictive.inputValue).distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;

        case 'email':
        this.cleanersService.findCleanerByEmail(predictive.inputValue).distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;

        case 'phone':
        this.cleanersService.findCleanerByPhone(predictive.inputValue).distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;

        case 'document':
        this.cleanersService.findCleanerByDNI(predictive.inputValue).distinctUntilChanged()
        .debounceTime(1000)
        .subscribe(result => {
          if(result instanceof Array){
              predictive.items = result;
            }else{
              predictive.items = [];
            }
        });
        break;
      }
  }

  public goToCleaner(data: object) {
      this.router.navigate(['/cleaners', data["id"]]);
  }
 
  public toggleSearch() {
      this.searchActive = (this.searchActive == 'active') ? 'inactive' : 'active';
  }


  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/search-cleaners.component.ts